import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { NFLookupSalesOrders } from "src/components/Shared/NewForms/NFLookupSalesOrders";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupCustomerInvoices } from "src/components/Shared/NewForms/NFLookupCustomerInvoices";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupFeature } from "src/components/Shared/NewForms/NFLookupFeature";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFLookupPriceType } from "src/components/Shared/NewForms/NFLookupPriceType";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupIncomeItem } from "src/components/Shared/NewForms/NFLookupIncomeItem";
import { NFLookupVatType } from "src/components/Shared/NewForms/NFLookupVatType";

export const CustomerInvoicesDetailServices = ({}) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <>
      <NFormTable fieldArray={"services"}>
        <NFLookupSalesOrders title={t("salesOrder")} fieldName="salesOrderId" width={200} />
        <NFLookupCustomerInvoices title={t("customerInvoice")} fieldName="customerInvoiceId" width={200} />
        <NFLookupProduct title={t("Product")} fieldName="productId" width={200} />
        <NFLookupFeature title={t("Feature")} fieldName="featureId" width={200} />
        <NFLookupUnit title={t("Unit")} fieldName="unitId" />
        <NFLookupPriceType fieldName="priceTypeId" title={t("PriceType")} width={200} />
        <NFLookupWarehouse title={t("Warehouse")} fieldName="warehouseId" width={200} companyId={watch("companyId")} />
        <NFIntInput title={t("Quantity")} fieldName="quantity" width={200} />
        <NFIntInput title={t("Price")} fieldName="price" width={200} />
        <NFIntInput title={t("Amount")} fieldName="amount" width={200} />
        <NFLookupIncomeItem title={t("IncomeItem")} fieldName="incomeItemId" width={200} />
        <NFLookupVatType title={t("vatType")} fieldName="vatTypeId" width={200} />
        <NFIntInput title={t("amountVat")} fieldName="amountVat" width={200} />
        <NFIntInput title={t("amountWithVat")} fieldName="amountWithVat" width={200} />
        <NFIntInput title={t("vatRate")} fieldName="vatRate" width={200} />
      </NFormTable>
    </>
  );
};
